(ns teamoesterreich.admin-mode.lebensretter.lr-user.modal.multi-marker-modal
  (:require [reagent.core :as r]
            [teamoesterreich.admin-mode.data.lr-clearance :as d-lrClearance]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.view-state :as vstate]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.not-interested :refer [not-interested]]
            [reagent-material-ui.icons.beenhere :refer [beenhere]]
            [reagent-material-ui.icons.bookmarks :refer [bookmarks]]
            [reagent-material-ui.icons.report :refer [report]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.watch-later :refer [watch-later]]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.helper :as h]
            ))


;:user.lrMarker/process
;:user.lrMarker/userWait
;:user.lrMarker/givenUp
;:user.lrMarker/ok
(defn markerIcon [marker]
  (case (keyword (or marker "new"))
    :userWait
    [watch-later {:style {}
                  :title "Wartet auf Teilnehmer-Aktion (zB: Dokument)"}]
    :process
    [bookmarks {:style {:color "grey"}
                :title "in Bearbeitung"}]
    :ok
    [beenhere {:style {:color "green"}
               :title "OK"}]
    :givenUp
    [not-interested {:style {:color "#ff8383"}
                     :title "vorerst aufgegeben (zB: TN reagiert nicht"}]
    :new
    [report {:style {:color "red"}
             :title "Zu bearbeiten oder neu"}]))


(defn- get-modal_ [!st !show-setMarker-multiple]
  (let [!marker (r/cursor !st [:lrMarker])
        !lrOwner (r/cursor !st [:lrOwner])
        !markerNotes (r/cursor !st [:lrMarkerNotes])
        !invalidated (r/cursor vstate/app-state [:lr-list :invalidated])
        !actual-user (r/cursor vstate/app-state [:actual-user])
        ]
    [mui/modal
     {:className        "correspondence-modal"
      :aria-labelledby  "simple-modal-title"
      :aria-describedby "simple-modal-description"
      :style            {:display        "flex"
                         :marginRight    "auto"
                         :marginLeft     "auto"
                         :alignItems     "center"
                         :justifyContent "center"}
      :open             (if @!show-setMarker-multiple true false)
      }
     (when @!show-setMarker-multiple

       [:div
        {
         :class "modal"
         :style {:width 750}}
        [:h3 "Marker für Auswahl setzen (" (count @!show-setMarker-multiple) " Teilnehmer ausgewählt)"]
        [mui/grid {:container  true
                   :direction  "row"
                   :justify    "space-between"
                   :alignItems "flex-start"}

         [mui/grid {:container false :item true :xs 6}
          [:div {:style   {:border          "1px solid grey" :margin "5px" :padding "5px" :cursor "hand"
                           :backgroundColor (cond (= @!marker "new") "#ffd6d2"
                                                  :else "#ffffff")}
                 :onClick #(reset! !marker "new")}
           [markerIcon :new]
           [:br]
           [:span "Zu bearbeiten oder neu"]
           ]
          ]

         [mui/grid {:container false :item true :xs 6}
          [:div {:style   {:border          "1px solid grey" :margin "5px" :padding "5px" :cursor "hand"
                           :backgroundColor (cond (= @!marker "ok") "#ffd6d2"
                                                  :else "#ffffff")}
                 :onClick #(reset! !marker "ok")}
           [markerIcon :ok]
           [:br]
           [:span "OK" [:br] "wird automatisch bei einer Freischaltung gesetzt"]
           ]
          ]

         [mui/grid {:container false :item true :xs 6}
          [:div {:style   {:border          "1px solid grey" :margin "5px" :padding "5px" :cursor "hand"
                           :backgroundColor (cond (= @!marker "userWait") "#ffd6d2"
                                                  :else "#ffffff")}
                 :onClick #(reset! !marker "userWait")}
           [markerIcon :userWait]
           [:br]
           [:span "Wartet auf Teilnehmer-Aktion (zB: Dokument)"]
           ]
          ]

         [mui/grid {:container false :item true :xs 6}
          [:div {:style   {:border          "1px solid grey" :margin "5px" :padding "5px" :cursor "hand"
                           :backgroundColor (cond (= @!marker "process") "#ffd6d2"
                                                  :else "#ffffff")}
                 :onClick #(reset! !marker "process")}
           [markerIcon :process]
           [:br]
           [:span "in Bearbeitung"]
           ]
          ]

         [mui/grid {:container false :item true :xs 6}
          [:div {:style   {:border          "1px solid grey" :margin "5px" :padding "5px" :cursor "hand"
                           :backgroundColor (cond (= @!marker "givenUp") "#ffd6d2"
                                                  :else "#ffffff")}
                 :onClick #(reset! !marker "givenUp")}
           [markerIcon :givenUp]
           [:br]
           [:span "Aufgegeben!" [:br] "`Ich will Lebensretter sein` wird deaktiviert und der  Teilnehmer bekommt ein Mail mit der Möglichkeit sich wieder zu aktivieren."]
           ]
          ]

         [mui/grid {:container false :item true
                    :xs        12
                    :style     {}}
          [mui/text-field {
                           :style           {:background-color (if (or (nil? @!markerNotes)) "#ffffff" "#ffd6d2")}
                           :fullWidth       true
                           :autoOk          true
                           :onChange        (fn [e]
                                              (log/debug "change marker " (:lrMarkerNotes @!st))
                                              (swap! !st assoc :lrMarkerNotes (h/event-value e)))
                           :label           (str "Notizen")
                           :multiline       true
                           :rows            5
                           :placeholder     "Hier kann der Admin sich Notizen machen"
                           :value           (or (:lrMarkerNotes @!st) "")
                           :InputLabelProps {:disableAnimation true :shrink true}
                           }]

          ]

         [mui/grid {:container false :item true
                    :xs        12
                    :style     {}}
          (if-not (d-rights/is-superuser?)
            [:div {:style {:margin "4px"}} "Aktueller Admin: " [:span {:style {:color "blue"}} ""]
             ]
            [mui/text-field {
                             :style           {:background-color (if (or (nil? @!lrOwner) (= (:lrOwner @!st) "")) "#ffffff" "#ffd6d2")
                                               :margin           "5px 0 5px 0" :width "300px"}
                             :autoOk          true
                             :onChange        (fn [e] (swap! !st assoc :lrOwner (h/event-value e)))
                             :label           (r/as-element [:span {:style {:color "#969613"}} "Admin setzen (nur Superuser)"])
                             :value           (or @!lrOwner "")
                             :InputLabelProps {:disableAnimation true :shrink true}
                             }]
            )
          ]

         [:div {:style {:display "none"}}
          "me: " (get-in @!actual-user [:name :first]) " " (get-in @!actual-user [:name :last]) [:br]
          (or (:lrMarker @!st) "new") "--" [:br]
          (:lrMarkerNotes @!st) "--" [:br]
          (pr-str (select-keys @!show-setMarker-multiple ["user-uuid" "tomId" "lrMarker" "lrMarkerNotes" "adminName"]))]

         [mui/grid {:container false :item true :xs 6 :style {:marginTop "7px"}}
          [mui/button
           {:variant   "contained"
            :startIcon (r/as-element [keyboard-arrow-left])
            :style     {:marginRight 50}
            :onClick   (fn []
                         (reset! !st {})
                         (reset! !show-setMarker-multiple false))
            }
           "Abbrechen"]
          ]

         [mui/grid {:container false :item true :xs 6 :style {:marginTop "7px"}}
          [mui/button
           {:variant   "contained"
            :disabled  (and (or (nil? @!marker))
                            (or (nil? @!markerNotes)))
            :startIcon (r/as-element [save])
            :color     "primary"
            :style     {:marginRight 50 :float "right"}
            :onClick   (fn [] (d-lrClearance/>setMarkerMultiple (merge {:tomIds       (reduce (fn [c [k v]] (if v (conj c k) c)) [] @!show-setMarker-multiple)
                                                                        :user-lrOwner (or @!lrOwner (str (get-in @!actual-user [:name :first]) " " (get-in @!actual-user [:name :last])))}
                                                                       (when (not= (:lrMarkerNotes @!st) "") [:user-lrMarkerNotes (:lrMarkerNotes @!st)])
                                                                       (when (not (nil? (:lrMarker @!st))) [:user-lrMarker (:lrMarker @!st)]))
                                                                (fn []
                                                                  (reset! !st {})
                                                                  (reset! !show-setMarker-multiple false)
                                                                  (reset! !invalidated true))))
            }
           "Marker für aktuelle Auswahl setzen"]
          ]]])
     ]
    ))


(defn get-modal [!show-setMarker-multiple]
  (log/debug "rerender marker modal")
  (let [!st (r/atom {:marker nil :lrMarkerNotes nil})]
    (when @!show-setMarker-multiple
      [get-modal_ !st !show-setMarker-multiple])))